import { CategoryApiFactory } from '@eloomi/eloomi-topics-persona-client/1.0';

import { authorizeClient } from '@/api/authorize-client';

const categoryApiClient = authorizeClient(CategoryApiFactory);

export function deleteCategories(categories: number[]) {
    return categoryApiClient.deleteBulk(categories);
}
